import { Image } from '@atoms/Images';
import Config from '@configs/Environments';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { AuthUserInfo, UserInfo } from './index';

const Header = () => {
    return (
        <HeaderWithStyled className='header'>
            <HeaderLogoWithStyled className="header__logo">
                <Link to={ '/' }>
                    <Image src="/img/genesis_logo.png" alt="Genesis" width={180} height={60} />
                    <HeaderLogoTextWithStyled className='header__logo__text'>ES</HeaderLogoTextWithStyled>
                </Link>
            </HeaderLogoWithStyled>
            <HeaderContentsWithStyled className='header__contents'>
                <HeaderLogoBadgeWithStyled className="badge ms-2">スイッチング支援システム<br />Electric Switching System</HeaderLogoBadgeWithStyled>
                {Config.OKTA_AUTH_MODE ? <AuthUserInfo /> : <UserInfo />}
            </HeaderContentsWithStyled>
        </HeaderWithStyled>
    );
};

const HeaderWithStyled = styled.header`
`
const HeaderLogoWithStyled = styled.div`
`
const HeaderLogoTextWithStyled = styled.div`
`
const HeaderLogoBadgeWithStyled = styled.span`
    background: #ebebeb;
    color: #555a5e;
    border: 1px solid #a3a3a3;
    letter-spacing: 1px;
    line-height: 1.2;
    margin: 14px 0 0 14px;
`
const HeaderContentsWithStyled = styled.div`
`

export default Header;